import type { PageSchemaOrgItem, SchemaOrgFunctions } from 'src/shared/prefetch';

import { isLoaded } from 'src/app/shared/utils/async';

import type { PetitionDetailsPageHeadData } from './types';

export function petitionDetailsPageSchemaOrg({
	prefetchedData,
	resolveUrl,
	defineArticle,
	defineBreadcrumb,
	definePerson,
}: {
	prefetchedData: PetitionDetailsPageHeadData;
	resolveUrl: (url: string) => string;
} & Pick<SchemaOrgFunctions, 'defineArticle' | 'defineBreadcrumb' | 'definePerson'>) {
	if (!isLoaded(prefetchedData.pageData)) {
		return undefined;
	}

	const { petition } = prefetchedData.pageData.pageData;
	const { ask, lastEditedAt, publishedAt, user, photo, tagsConnection } = petition;

	const article = defineArticle({
		headline: ask,
		...(photo?.petitionLarge && { image: [resolveUrl(photo.petitionLarge.url)] }),
		datePublished: publishedAt ?? undefined,
		...(lastEditedAt && { dateModified: lastEditedAt }),
		author: [
			definePerson({
				name: user.displayName,
				url: resolveUrl(`/u/${user.id}`),
			}),
		],
	});

	const results: PageSchemaOrgItem[] = [article];

	if (tagsConnection?.nodes.length) {
		const breadcrumb = defineBreadcrumb({
			itemListElement: [
				{ name: 'Change.org', item: 'https://www.change.org/' },
				{
					name: tagsConnection.nodes[0].name,
					item: `https://www.change.org/topic/${tagsConnection.nodes[0].slug}`,
				},
				{ name: ask },
			],
		});
		results.push(breadcrumb);
	}

	return results;
}
